export const createStyles = (theme?: any) => {
  const isDark = theme?.palette?.mode === 'dark';
  const primary = theme?.palette?.primary?.main ?? '#5B35A5';
  const titleColor = isDark ? '#FFFFFF' : '#000000DE !important';
  const iconBackground = isDark ? '#D0BCFA' : primary;
  const iconColor = isDark ? '#121212' : '#FFFFFF';

  return {
    sidebarWrapper: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      fontFamily: theme.typography.fontFamily,
    },
    buttonWrapper: {
      px: { xs: '16px', md: '12px' },
      pt: { xs: '16px', md: '12px' },
      'margin-left': '-8px',
    },
    backButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    sidebarContent: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
      px: { xs: '12px', md: '12px' },
    },
    listWrapper: {
      flex: 1,
      minHeight: 0,
      overflowY: 'auto',
    },
    headerWrapper: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      gap: '11px',
      minWidth: 0,
      my: '16px',
    },
    headerIcon: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: iconBackground,
      flexShrink: 0,
      color: iconColor,
    },
    title: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: 600,
      fontStyle: 'normal',
      fontSize: '1.25rem',
      lineHeight: '160%',
      letterSpacing: '0px',
      flexShrink: 1,
      minWidth: 0,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: titleColor,
    },
    createButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      height: '42px',
      width: '100%',
    },
  };
};
